import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { ProfileContext } from "../../reducers/profile";

export default ({ children, ...rest }) => {
  const {
    state: { is_auth, is_admin },
  } = useContext(ProfileContext);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        is_auth ? (
          is_admin ? (
            <Redirect
              to={{
                pathname: "/results",
                state: { from: location },
              }}
            />
          ) : (
            children
          )
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};
